// GLOBAL STATE MANAGER
/*
 *
 */
const getDefaultState = function() {
    return {
        // Initial state
        settings: {
            splashScreen: false, // true -> if you want to enable an intro page
            hasSplashed: true, // true -> if the chatbot has already splashed
            toBeInitialized: true, // true -> if the chatbot has to be Initialized
            header: false, // true -> if you want the header with custom brand logo
            outerMenu: false, // true -> if you want a menù with suggestions
            showOuterMenu: false, // true -> the outerMenu is open
            hasCustomPanel: true, // true -> show the custom panel (to be customized for each scenario TODO)
            userInput: { // user input settings
                placeholder: "Type a message...",
            },
        },
        // messages represents the history of the messages sent in the conversation. As the conversation
        // is global for each user, the history will be kept in memory even if the chatbot page is reloaded
        messages: [ ],
        // defaultMessages is a variable that takes into account the cases in which we had to send the same message:
        //  - start conversation;
        //  - fallback;
        //  - no backend connection.
        defaultMessages: {
            startConversation: {
                type: "start",
                text: "Hi!",
                options: {
                    links: [
                        {text: "Ask me", url: "", action: "", },
                    ],
                },
            },
            noBackendAnswer: {
                type: "response",
                text: "Sorry, I cannot understand you...",
            },
            noBackendConnection: [
                {
                    type: "response",
                    text: "There is something wrong...",
                },
                {
                    type: "response",
                    text: "Check the internet connection, please",
                },
            ],
        },
        userChatOptions: {
            conversationId: "", // conversationId is the identifier of the conversation
            interactionMode: 0, // interactionMode is the strategy through which doing the conversation
            isCustomPanelOpen: false, // true -> if the panel is opened,
            activateTooltip: false
        },
        chatState: {
            recording: {
                isActive: false
            }
        }
    };
};

const state = getDefaultState();


const getters = {
    getSettings: (state) => {
        return state.settings;
    },
    getMessages: (state) => {
        return state.messages;
    },
    getDefaultMessages: (state) => {
        return state.defaultMessages;
    },
    getUserChatOptions: (state) => {
        return state.userChatOptions;
    },
    getChatState: (state) => {
        return state.chatState;
    },
};

const actions = {
    resetState ({ commit, }) {
        commit("resetState");
    },
    setSettings({commit,}, settingsState) {
        commit("setSettings", settingsState);
    },
    setMessages({commit,}, messagesState) {
        commit("setMessages", messagesState);
    },
    setUserChatOptions({commit,}, userChatOptionsState) {
        commit("setUserChatOptions", userChatOptionsState);
    },
    setChatState({commit,}, chatStateState) {
        commit("setChatState", chatStateState);
    },
};

const mutations = {
    resetState (state) {
        Object.assign(state, getDefaultState());
    },
    setSettings(state, settings) {
        state.settings = settings;
        // console.log('ChatbotState -> setSettings: ', state.settings);
    },
    setMessages(state, messagesState) {
        state.messages = messagesState;
        // console.log('ChatbotState -> setMessages: ', state.messages);
    },
    setUserChatOptions(state, userChatOptionsState) {
        state.userChatOptions = userChatOptionsState;
        // console.log('ChatbotState -> setUserChatOptions: ', state.userChatOptions);
    },
    setChatState(state, chatStateState) {
        state.chatState = chatStateState;
        // console.log('ChatbotState -> setChatState: ', state.chatState);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
